<template>
  <div class="footer">
    <div class="kw clearfix">
      <div class="footerLeft">
        <div class="footerLink" style="width: 170px;">
          <div class="f18 fb">About us</div>

          <div class="pt25">


            <template v-if="type == 'home'">
              <div class="footerLinkItem"><a href="javascript:;" @click="scrollToSection('h1')" >JS EXHIBITION</a></div>
              <div class="footerLinkItem"><a href="javascript:;" @click="scrollToSection('h2')" >SOLUTIONS</a></div>
              <div class="footerLinkItem"><a href="javascript:;" @click="scrollToSection('h3')" >PORTFOLIO</a></div>
            </template>
            <template v-else>
              <div class="footerLinkItem"><router-link to="/middleEastAfrica/index?pageId=h1" >JS EXHIBITION</router-link></div>
              <div class="footerLinkItem"><router-link to="/middleEastAfrica/index?pageId=h2" >SOLUTIONS</router-link></div>
              <div class="footerLinkItem"><router-link to="/middleEastAfrica/index?pageId=h3" >PORTFOLIO</router-link></div>
            </template>


          </div>
        </div>


        <div class="footerLink" style="width: 450px;">
          <div class="f18 fb">Contact us</div>

          <div class="pt25">



            <div class="footerLinkItem" v-if="configInfo.tel"><span class="footerLinkIcon"><i class="iconfont icon-dianhua"></i>{{configInfo.tel}}</span></div>
            <div class="footerLinkItem" v-if="configInfo.webSite"><span class="footerLinkIcon"><i class="iconfont icon-wangluo"></i>{{configInfo.webSite}}</span></div>
            <div class="footerLinkItem" v-if="configInfo.email"><span class="footerLinkIcon"><i class="iconfont icon-email"></i>{{configInfo.email}}</span></div>
            <div v-if="configInfo.address" v-html="configInfo.address"></div>
            <!-- <div class="footerLinkItem">
              <div class="footerLinkIcon"><i class="iconfont icon-zuobiao"></i>
                  Office 1901,JBc 5,cluster W, Jumeirah Lakes Towers,
                  Dubai, United Arab Emirates
              </div>
            </div> -->




          </div>
        </div>



      </div>
      <div class="footerRight tr">
        <router-link to="/" >
          <img src="@/assets/images/footLogo.jpg" />
        </router-link>

        <footerShaer/>
      </div>
    </div>
  </div>
</template>

<script>
import footerShaer from '@/components/footerShaer.vue'
export default {
  components:{
    footerShaer
  },
  props: {
    configInfo: {},
    type:{
      default:''
    }
  },
  methods:{
    scrollToSection(sectionId){
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }

    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/middleEastAfrica/footer.vue